// extracted by mini-css-extract-plugin
export var ClearBackground = "index-module--ClearBackground--526d0";
export var FillBar = "index-module--FillBar--225d7";
export var MoneyIndicator = "index-module--MoneyIndicator--98147";
export var MoneyIndicatorWrapper = "index-module--MoneyIndicatorWrapper--898b9";
export var RemainderBar = "index-module--RemainderBar--53960";
export var fadeIn = "index-module--fadeIn--13798";